/**
 * Ticket Z14: Serverfunktionen der öffentlichen Einstiegsseite /100-tage.
 *
 * Öffentlich (ohne Anmeldung): Seiteninhalte und Angebotsliste — beides nur in
 * der öffentlichen Projektion, ohne interne Notiz und ohne Weiterleitungsziel.
 * Intern: Pflege der Texte (Administratoren und Redaktion) sowie das
 * Weiterleitungsziel (nur Administratoren).
 */

import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { landingSaveSchema, redirectTargetSchema } from "@/lib/landing-hundert-tage";

export const getLandingContent = createServerFn({ method: "GET" }).handler(async () => {
  const { loadPublicLanding } = await import("@/lib/landing-hundert-tage.server");
  return loadPublicLanding();
});

export const getTrainingOffers = createServerFn({ method: "GET" }).handler(async () => {
  const { loadPublicOffers } = await import("@/lib/landing-hundert-tage.server");
  return loadPublicOffers();
});

export const getLandingAdmin = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { assertStaff } = await import("@/lib/landing-hundert-tage.access.server");
    await assertStaff(context.supabase, context.userId);
    const { loadAdminLanding } = await import("@/lib/landing-hundert-tage.server");
    return loadAdminLanding(context.supabase as never);
  });

export const saveLandingContent = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((input: unknown) => landingSaveSchema.parse(input))
  .handler(async ({ context, data }) => {
    const { assertStaff } = await import("@/lib/landing-hundert-tage.access.server");
    await assertStaff(context.supabase, context.userId);
    const { saveLandingTexts, loadAdminLanding } = await import(
      "@/lib/landing-hundert-tage.server"
    );
    await saveLandingTexts(context.supabase as never, data);
    return loadAdminLanding(context.supabase as never);
  });

export const setLandingRedirect = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((input: unknown) => redirectTargetSchema.parse(input))
  .handler(async ({ context, data }) => {
    const { assertAdmin } = await import("@/lib/landing-hundert-tage.access.server");
    await assertAdmin(context.supabase, context.userId);
    const { applyRedirectTarget, loadAdminLanding } = await import(
      "@/lib/landing-hundert-tage.server"
    );
    await applyRedirectTarget(context.supabase as never, data.target ?? null);
    return loadAdminLanding(context.supabase as never);
  });
